import type { Result } from "@pdfking/errors"
import { Failure, Success } from "@pdfking/errors"
import { StringQ } from "@pdfking/structs"

import { AlmostNullQ } from "#public"

export const EnsureString = (value: unknown): Result<string> =>
  StringQ(value) && !AlmostNullQ(value)
    ? Success(value)
    : Failure("REQUIRED_ERROR", { input: value })
